import _ from "lodash";

import { Card, CardContent } from "@/components/ui/card";
import { VenueAIEnrichmentStep } from "@/pages/venues/create/components/ai-enrichment-step";
import { VenueCreateBasicInfoStep } from "@/pages/venues/create/components/basic-info-step";
import { VenueMediaForm } from "@/pages/venues/create/components/media-step";
import {
  Stepper,
  useVenueCreateForm,
} from "@/pages/venues/create/hooks/use-venue-create-form";

export const VenuesCreate = () => (
  <Stepper.Provider variant="vertical">
    <VenuesCreateStepper />
  </Stepper.Provider>
);

const VenuesCreateStepper = () => {
  const { methods } = useVenueCreateForm();

  return (
    <div className="flex flex-col mb-20">
      <Stepper.Navigation>
        {methods.all.map((step) => (
          <Stepper.Step
            key={step.id}
            of={step.id}
            onClick={() => methods.goTo(step.id)}
          >
            <Stepper.Title>{step.title}</Stepper.Title>
            {step.description && (
              <Stepper.Description>{step.description}</Stepper.Description>
            )}
            {methods.current.id === step.id && (
              <Stepper.Panel>
                <Card className="p-4">
                  <CardContent className="p-0">
                    {methods.switch({
                      basicInfo: () => <VenueCreateBasicInfoStep />,
                      aiEnrichment: () => <VenueAIEnrichmentStep />,
                      media: () => <VenueMediaForm />,
                    })}
                  </CardContent>
                </Card>
              </Stepper.Panel>
            )}
          </Stepper.Step>
        ))}
      </Stepper.Navigation>
    </div>
  );
};
